import { gql } from 'graphql-request';
import { useQuery } from '@tanstack/react-query';
import useGraphQLClient from '../../../app/hooks/useGraphQLClient';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import moment from 'moment';
import IDocumentDownloadLog from '../interfaces/IDocumentDownloadLog';
import useAppLog from '../../../app/features/log/hooks/useAppLog';

const useDocumentDownloadLogs = (startReleaseDate: Date, endReleaseDate: Date) => {
	const authContext = useAuthContext();
	const graphQLClient = useGraphQLClient();

	const appLog = useAppLog();

	const query = useQuery<IDocumentDownloadLog[] | null, Error>(
		[
			'DocumentDownloadLogs',
			moment(startReleaseDate).format('DD/MM/YYYY HH:mm'),
			moment(endReleaseDate).format('DD/MM/YYYY HH:mm'),
		],
		async () => {
			try {
				const data = (await graphQLClient.request(
					gql`
						query ($documentSubTypeTag: String, $startReleaseDate: Date, $endReleaseDate: Date) {
							documentDownloadLogs(
								documentSubTypeTag: $documentSubTypeTag
								startReleaseDate: $startReleaseDate
								endReleaseDate: $endReleaseDate
							) {
								document {
									id
									name
									fileName
									documentType
									documentFormat
									releaseDate
									version
								}
								fund {
									id
									name
								}
								company {
									id
									name
									group {
										id
										name
									}
								}
								accessTime
								isImpersonated
							}
						}
					`,
					{
						startReleaseDate: moment(startReleaseDate).format('YYYY-MM-DD'),
						endReleaseDate: moment(endReleaseDate).format('YYYY-MM-DD'),
						documentSubTypeTag: 'capital_call',
					},
				)) as { documentDownloadLogs: IDocumentDownloadLog[] };
				return data.documentDownloadLogs;
			} catch (e) {
				appLog.exception(e, { component: 'useDocumentAccess' });
				return null;
			}
		},
		{
			// The query will not execute until
			enabled:
				appLog &&
				!!startReleaseDate &&
				!!endReleaseDate &&
				authContext.isInvestor === false &&
				authContext.isAuthenticated,
		},
	);

	return query;
};

export default useDocumentDownloadLogs;
